/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `pending` - pending
 * * `running` - running
 * * `completed` - completed
 * * `failed` - failed
 * * `cancelled` - cancelled
 * @export
 */
export const DatasetPipelineStatus = {
  pending: 'pending',
  running: 'running',
  completed: 'completed',
  failed: 'failed',
  cancelled: 'cancelled',
} as const;
export type DatasetPipelineStatus = (typeof DatasetPipelineStatus)[keyof typeof DatasetPipelineStatus];

export function instanceOfDatasetPipelineStatus(value: any): boolean {
  for (const key in DatasetPipelineStatus) {
    if (Object.prototype.hasOwnProperty.call(DatasetPipelineStatus, key)) {
      if ((DatasetPipelineStatus as Record<string, DatasetPipelineStatus>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function DatasetPipelineStatusFromJSON(json: any): DatasetPipelineStatus {
  return DatasetPipelineStatusFromJSONTyped(json, false);
}

export function DatasetPipelineStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatasetPipelineStatus {
  return json as DatasetPipelineStatus;
}

export function DatasetPipelineStatusToJSON(value?: DatasetPipelineStatus | null): any {
  return value as any;
}
